import { router } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import AskQuestionAnswerForm from '@/components/forms/AskQuestionAnswerForm';
import FormWrapper from '@/components/forms/FormWrapper';
import { useAuth } from '@/contexts/authContext';
import { i18n } from '@/utils/i18n';

const AddQuestion = () => {
  const { state } = useAuth();

  return (
    <SafeAreaView style={styles.safe} edges={['bottom']}>
      <FormWrapper scrollEnable={false}>
        <View style={styles.container}>
          <AskQuestionAnswerForm
            npoId={state.signUpData?.loginEmail?.npoId ?? ''}
            messageOnSuccess={i18n.t('question.add.success_message')}
            onSuccess={() => router.back()}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

export default AddQuestion;

const styles = StyleSheet.create({
  container: {
    paddingTop: 34,
    flex: 1
  },
  safe: {
    flex: 1
  }
});
